export default __webpack_public_path__ + "static/media/alephbotic.3cea25d3.png";